import { ChangeEvent, useEffect, useState } from "react";
import { useAbortController } from "./useAbortController";
import {
  IPaginacionApi,
  ITablaTiposDocumentos,
  ITableDTO,
  IfilteApi,
} from "../../../Interfaces/gestionDocumentos/ITipoDocumento";
import tipoDocumentoService from "../../../services/gestionDocumentos/tipoDocumentoService";
import axios from "axios";


export const useVistaTiposDocumentos = () => {
  const { handleAbortController } = useAbortController();
  const [loading, setLoading] = useState<boolean>(false);
  const [items, setItems] = useState<ITablaTiposDocumentos[]>([]);
  const [total, setTotal] = useState(0);
  const [responseAPI, setresponseAPI] = useState<ITableDTO>();

  const [filter, setFilter] = useState<IfilteApi>({
    skip: 0,
    take: 50,
    search: "",
  });

  const postListaTabla = (filter: IfilteApi) => {
    setLoading(true);
    tipoDocumentoService
      .listarTipos(filter, handleAbortController())
      .then((res) => {
        if (res.status == 200) {
          setresponseAPI(res.data);
          setItems(res?.data?.items);
          setTotal(res?.data?.total);
          setLoading(false);
        }
      })

      .catch((e) => {
        if (axios.isCancel(e)) {
         
        } else {
          console.error("Error en la solicitud:", e?.message);
          setLoading(false);
        }
      });
  };

  const limpiarFiltro = () => {
    setFilter({
      skip: 0,
      take: 50,
      search: "",
    });
  };

  const onChangeTake = (take: number) => {
    setFilter({ ...filter, take: take });
  };

  const onChangeSkip = (skip: number) => {
    setFilter({ ...filter, skip: skip });
  };

  //   const onChangeSearchTabla = (
  //     event: ChangeEvent<HTMLInputElement> | React.MouseEvent<HTMLSpanElement>,
  //     data: InputOnChangeData
  //   ) => {
  //     if (event !== undefined) {
  //       setFilterPersona({ ...filterPersona, search: data.value });
  //     }
  //   };

  const onChangeTextSearch = (
    ev?: React.ChangeEvent<HTMLInputElement>,
    newValue?: string
  ) => {
    if (newValue != undefined) {
      setFilter({ ...filter, search: newValue });
      if (newValue.length == 0) {
        _onClearSearch();
      }
    }
  };

  const _onClearSearch = () => {
    setFilter({
      ...filter,
      search: "",
    });
  };

  const paginacionTable: IPaginacionApi = {
    onChangeTake: onChangeTake,
    onChangeSkip: onChangeSkip,
    totalPagesPagination: Number.parseInt(responseAPI?.pages!),
    skipPagination: filter.skip,
    takePagination: filter.take,
    isVisible: true,
    isLoading: loading,
    total: items ? Number.parseInt(responseAPI?.total!) : 0,
  };

  useEffect(() => {
    postListaTabla(filter);
  }, [filter]);

  return {
    items,
    loading,
    filter,
    setFilter,
    limpiarFiltro,
    total,
    postListaTabla,
    paginacionTable,
    onChangeTextSearch,
  };
};
